import { ParagraphObj } from "@/app/pages/businessDirectory/description/DescriptionContent";

interface DirectoryParagraphs {
	"de": ParagraphObj[];
	"hu": ParagraphObj[];
	"pl": ParagraphObj[];
	"us": ParagraphObj[];
}

export const getParagraphs = (params: BusinessDirectoryDescriptionParameter): DirectoryParagraphs => ({
	"de": [
		{
			"text": `Durchsuchen Sie die Dun & Bradstreet Data Cloud und gewinnen Sie Erkenntnisse über Millionen von
                    ${params.businessDirectoryParagraphLink1Label ?? "österreichischen"}
                    Unternehmen, die für Ihre Geschäftsbeziehungen
                    ${params.countryCode === "ch" ? "" : "Sie"}
                    von Interesse sein könnten.
                `,
		},
		{
			"text": "Wenn Sie tiefer eintauchen wollen, können Sie auf verschiedene Weise auf die Data Cloud zugreifen: über unsere Lösungen, wie D&B Hoovers zur Beschleunigung des Vertriebs oder D&B Finance Analytics für Einblicke in finanzielle Risiken, über unsere APIs oder über Partnerlösungen.",
		},
		{
			"hrefUrl": params.businessDirectoryParagraphLink2,
			"label": params.businessDirectoryParagraphLink2Label ?? "D&B Hoovers",
			"text": "Mit _link_ können Sie gezielte Leads und neue Verkaufschancen aufdecken und auf einfache Weise Recherchen über öffentliche und private Unternehmen durchführen, um Ihren Verkaufsprozess zu beschleunigen.",
		},
		{
			"hrefUrl": params.businessDirectoryParagraphLink3,
			"label": params.businessDirectoryParagraphLink3Label ?? "D&B Finance Analytics",
			"text": "Mit _link_ oder unseren Business Credit Reports können Sie Kreditentscheidungen mit Vertrauen treffen und Ihre operative Effizienz steigern, indem Sie Dun & Bradstreets unübertroffene Risikoeinblicke nutzen.",
		},
	],
	"hu": [
		{
			"text": "Keressen a Dun & Bradstreet Data Cloud-ban, amely több százmillió üzleti rekordot fed le, és fedezze fel az Önt érdeklő vállalatokat. Vagy keressen iparági könyvtárunkban, és tekintse meg iparági jelentéseink kiemelt elemeit, hogy betekintést nyerjen a növekvő piacokba, és megértse a trendeket és előrejelzéseket. Használja az iparági betekintést a vállalatok megcélzásához méret, elhelyezkedés, versenytársak és egyéb tényezők alapján. Iparági elemző eszközeink segítenek az értékesítési csapatoknak az érdeklődők üzleti kihívásainak, a hívásfelkészítési kérdéseknek, az iparági előrejelzéseknek és még sok másnak a kutatásában.",
		},
		{
			"text": "Ha mélyebbre szeretne ásni, többféle módon is hozzáférhet a Data Cloud-hoz megoldásainkon keresztül: például a D&B Hoovers az értékesítés felgyorsításához vagy a D&B Finance Analytics Credit Intelligence a pénzügyi kockázatokra vonatkozó betekintésért; API-inkon keresztül; vagy partneri megoldásokon keresztül.",
		},
		{
			"hrefUrl": params.businessDirectoryParagraphLink2,
			"label": params.businessDirectoryParagraphLink2Label ?? "D&B Hoovers",
			"text": "A _link_ segítségével célzott érdeklődőket és új értékesítési lehetőségeket fedezhet fel, és könnyen végezhet nyilvános és magánvállalati kutatásokat az értékesítési folyamat felgyorsítása érdekében.",
		},
		{
			"hrefUrl": params.businessDirectoryParagraphLink3,
			"label": params.businessDirectoryParagraphLink3Label ?? "D&B Finance Analytics",
			"text": "A _link_ Credit Intelligence vagy a Business Credit riportok segítségével magabiztosan hozhat hitelezési döntéseket, és növelheti működési hatékonyságát, kihasználva a Dun & Bradstreet páratlan kockázati elemzéseit.",
		},
	],
	"pl": [
		{
			"text": "Przeszukaj chmurę danych Dun & Bradstreet i uzyskaj wgląd w dane milionów polskich firm, które mogą być interesujące dla Twojego biznesu.",
		},
		{
			"text": "Pozyskaj szczegółowe informacje z chmury danych poprzez rozwiązanie D&B Hoovers do wsparcia sprzedaży lub D&B Finance Analytics do analizy ryzyka finansowego kontrahentów przy pomocy łączników API lub poprzez rozwiązania partnerskie.",
		},
		{
			"hrefUrl": params.businessDirectoryParagraphLink2,
			"label": params.businessDirectoryParagraphLink2Label ?? "D&B Hoovers",
			"text": "Dzięki _link_ możesz znaleźć interesujące zapytania lub nowe szanse sprzedażowe, a także łatwo sprawdzić publiczne i prywatne przedsiębiorstwa w celu przyspieszenia procesu sprzedażowego.",
		},
		{
			"hrefUrl": params.businessDirectoryParagraphLink3,
			"label": params.businessDirectoryParagraphLink3Label ?? "D&B Finance Analytics",
			"text": "Dzięki _link_ Credit Intelligence lub naszym raportom dotyczącym kredytów biznesowych, możesz pewniej podejmować decyzje kredytowe i zwiększać efektywność operacyjną, mając od Dun & Bradstreet bezkonkurencyjny wgląd w ryzyko.",
		},
	],
	"us": [
		{
			"text": "Search the Dun & Bradstreet Data Cloud, covering hundreds of millions of business records to discover insights about companies of interest to you. Or, search our industry directory to view highlights from our industry reports to gain visibility into growing markets and understand trends and forecasts. Use industry insights to target companies based on size, location, competitors and more. Our industry analysis tools help sales teams research prospects’ business challenges, call preparation questions, industry forecasts, and more.",
		},
		{
			"text": "If you want to go deeper, you can access the Data Cloud in multiple ways: through our solutions, such as D&B Hoovers for sales acceleration or D&B Finance Analytics Credit Intelligence for financial risk insights; through our APIs; or through partner solutions.",
		},
		{
			"hrefUrl": params.businessDirectoryParagraphLink2,
			"label": params.businessDirectoryParagraphLink2Label ?? "D&B Hoovers",
			"text": "With _link_, you can uncover targeted leads and new sales opportunities, and easily perform public and private company research to speed your selling process.",
		},
		{
			"hrefUrl": params.businessDirectoryParagraphLink3,
			"label": params.businessDirectoryParagraphLink3Label ?? "D&B Finance Analytics",
			"text": "With _link_, or our Business Credit reports, you can make credit decisions with confidence and increase your operational efficiency, leveraging Dun & Bradstreet’s unrivaled risk insights.",
		},
	]
});

export interface ExportedTypeMarker {
}

export interface BusinessDirectoryDescriptionParameter extends ExportedTypeMarker {
	businessDirectoryParagraphLink1Label?: string;
	businessDirectoryParagraphLink1?: string;
	businessDirectoryParagraphLink2Label?: string;
	businessDirectoryParagraphLink2?: string;
	businessDirectoryParagraphLink3Label?: string;
	businessDirectoryParagraphLink3?: string;
	countryCode?: string;
}
